// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import styled from "styled-components";
import { EffectCoverflow, Navigation } from "swiper";
import { useRouter } from "next/router";
import { Grid, Select } from "antd";

import { Flex, RATypography } from "@/components/customs";
import { getSettings } from "@/stores/slices/settingSlice";
import {
	SEChevronLeft,
	SEChevronRight,
	SEClock,
	SEPartnerFleetFavicon,
	SERAFleetFavicon,
	SESpeedometer,
	SEUserGroup,
} from "@/components/svgs";
import { AircraftOwnershipTag } from "@/components/molecules";
import { WorldMapRange } from "@/components/molecules/WorldMapRange";
import { AIRCRAFT_LOCATIONS, AIRCRAFT_PROVIDER } from "@/config/constants";
import s from "./AircraftSelectionTablet.module.css";
import { PATH_ROUTES } from "@/config/routes";
import { SvgArrowDown, SvgArrowLeft } from "@/assets/icons";
import Image from "next/image";

const { useBreakpoint } = Grid;

export const AircraftSelectionTablet = ({ open, onUpdateOpen, onClose }: any) => {
	const swiperRef = useRef(null);
	const router = useRouter();
	const { xl } = useBreakpoint();

	const { aircraft_categories = [] } = useSelector(getSettings);

	const [selectedCategory, setSelectedCategory] = useState(aircraft_categories?.[0] ?? null);
	const [location, setLocation] = useState(AIRCRAFT_LOCATIONS.DETROIT);
	const [exploreFleet, setExploreFleet] = useState(false);
	const [openSelect, setOpenSelect] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);

	const aircraftType = selectedCategory?.aircraft_type_list?.[activeIndex] ?? null;
	const isPartner = aircraftType?.aircraft_provider === AIRCRAFT_PROVIDER.PARTNER || !exploreFleet;
	const aircraftTypeLength = selectedCategory?.aircraft_type_list?.length ?? 0;
	const aircraftCategories = aircraft_categories?.map((c: any) => ({
		...c,
		label: (
			<RATypography variant="gilda1" style={{ lineHeight: "54px" }}>
				{c.name}
			</RATypography>
		),
	}));

	useEffect(() => {
		if (swiperRef.current) {
			swiperRef.current.slideTo(activeIndex);
		}
	}, [activeIndex]);

	useEffect(() => {
		if (aircraft_categories?.length > 0) {
			setSelectedCategory(aircraft_categories[0]);
		}
	}, [aircraft_categories]);

	useEffect(() => {
		if (!open) {
			setSelectedCategory(aircraft_categories?.[0] ?? null);
			setLocation(AIRCRAFT_LOCATIONS.DETROIT);
			setExploreFleet(false);
			setActiveIndex(0);
		}
	}, [open]);

	const handleSelectCategory = (c: any) => {
		setSelectedCategory(c);
		setActiveIndex(0);
	};

	const handleNavigateToTrustedPartners = () => {
		if (isPartner) {
			router.push(PATH_ROUTES.PATH_TRUSTED_PARTNERS);
		} else {
			if (aircraftType) {
				router.push(`${PATH_ROUTES.PATH_AIRCRAFT_TYPES}/${aircraftType.slug}`);
			}
		}
		onClose();
	};

	return (
		<div className={s.container}>
			<div className={s.close_button} onClick={() => onUpdateOpen(false)}>
				<SvgArrowLeft color="#A8A8A8" />
				Menu
			</div>
			<StyledSelect
				suffixIcon={
					<div
						style={{
							transition: "transform 0.2s",
							transform: !openSelect ? `rotate(0turn)` : "rotate(0.5turn)",
						}}
					>
						<SvgArrowDown width={16} />
					</div>
				}
				fieldNames={{
					label: "label",
					value: "_id",
				}}
				showSearch={false}
				style={{ width: "100%", height: 56 }}
				popupRender={(originNode) => <DropdownRender>{originNode}</DropdownRender>}
				value={selectedCategory?._id}
				options={aircraftCategories}
				onChange={(_, option) => handleSelectCategory(option)}
				onOpenChange={(open) => setOpenSelect(open)}
			/>
			<RATypography top={40} bottom={24} variant="gilda3">
				{selectedCategory?.name}
			</RATypography>
			<div style={{ position: "relative" }}>
				{exploreFleet && (
					<div className={s.explore_fleet_wrapper}>
						<button
							className={s.swiper_button_prev}
							style={{
								visibility: aircraftTypeLength > 1 ? "visible" : "hidden",
							}}
						>
							<SEChevronLeft />
						</button>
						<button
							className={s.swiper_button_next}
							style={{
								visibility: aircraftTypeLength > 1 ? "visible" : "hidden",
							}}
						>
							<SEChevronRight />
						</button>
						<Swiper
							effect={"coverflow"}
							grabCursor={true}
							centeredSlides={true}
							slidesPerView={3}
							slidesPerGroup={1}
							coverflowEffect={{
								slideShadows: false,
								rotate: 0,
								stretch: -160,
								depth: 100,
								scale: 1,
							}}
							speed={1000}
							modules={[EffectCoverflow, Navigation]}
							navigation={{
								prevEl: `.${s.swiper_button_prev}`,
								nextEl: `.${s.swiper_button_next}`,
							}}
							onSwiper={(w) => {
								swiperRef.current = w;
							}}
							onSlideChange={(w) => setActiveIndex(w.activeIndex)}
							onBeforeDestroy={() => {
								swiperRef.current = null;
							}}
						>
							{selectedCategory?.aircraft_type_list?.map((item: any) => {
								const mainImage =
									item.images?.find((e) => e.type === "MAIN")?.url ??
									item.images?.[0]?.url ??
									"/images/example/aircraft_light_turbo.png";

								return (
									<SwiperSlide key={item._id} className={s.explore_fleet_swiper_slide}>
										<Flex alignItems="center" gap={12}>
											<div style={{ width: "100%" }}>
												<Flex
													alignItems="center"
													gap={8}
													className={s.explore_fleet_swiper_slide_header}
												>
													<AircraftOwnershipTag isPartner={isPartner} />
													<RATypography variant="sub-heading3">{item.name}</RATypography>
												</Flex>
												<div
													style={{
														position: "relative",
														marginBlock: "32px 24px",
													}}
												>
													<div style={{ width: "100%", height: 130, position: "relative" }}>
														<Image
															fill
															sizes="100vw"
															src={mainImage}
															alt={item.name}
															style={{
																objectFit: "contain",
																objectPosition: "center",
															}}
														/>
													</div>
													<div className={s.explore_fleet_swiper_slide_name_overlay}>
														<RATypography variant="sub-heading3" align="center">
															{item.name}
														</RATypography>
													</div>
												</div>
												<Flex
													alignItems="center"
													justifyContent="center"
													className={s.explore_fleet_swiper_slide_info}
												>
													<div>
														<Flex gap={16}>
															<SEUserGroup />
															<Flex alignItems="center">
																<RATypography variant="gilda1">
																	{item.properties?.max_pax ?? 0}
																	{item.properties?.max_pax_symbol ?? ""}
																</RATypography>
																<RATypography variant="dm_sans1" left={8}>
																	{item.properties?.max_pax_unit}
																</RATypography>
															</Flex>
														</Flex>
														<Flex gap={16} style={{ marginBlock: 12 }}>
															<SEClock />
															<Flex alignItems="center">
																<RATypography variant="gilda1">
																	{item.properties?.max_fly_time ?? 0}
																	{item.properties?.max_fly_time_symbol ?? ""}{" "}
																	{item.properties?.max_fly_time_unit}
																</RATypography>
																<RATypography variant="dm_sans1" left={8}>
																	Range
																</RATypography>
															</Flex>
														</Flex>
														<Flex gap={16}>
															<SESpeedometer />
															<Flex alignItems="center">
																<RATypography variant="gilda1">
																	{item.properties?.cruising_speed ?? 0}
																	{item.properties?.cruising_speed_symbol ?? ""}{" "}
																	{item.properties?.cruising_speed_unit}
																</RATypography>
																<RATypography variant="dm_sans1" left={8}>
																	Cruise Speed
																</RATypography>
															</Flex>
														</Flex>
													</div>
												</Flex>
											</div>
										</Flex>
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
				)}
				<div
					className={s.world_map_wrapper}
					style={exploreFleet ? { opacity: 0, visibility: "hidden" } : { opacity: 1, visibility: "visible" }}
				>
					<Flex alignItems="center" justifyContent="space-between">
						<div style={{ flex: 1, padding: "24px 12px" }}>
							<Flex alignItems="center">
								<SEClock />
								<RATypography variant="gilda1" left={16}>
									{selectedCategory?.min_fly_times_hours ?? 0}-
									{selectedCategory?.max_fly_times_hours ?? 0} Hours
								</RATypography>
								<RATypography variant="dm_sans1" left={4}>
									Range
								</RATypography>
							</Flex>
							<Flex alignItems="center" style={{ marginBlock: 12 }}>
								<SEUserGroup />
								<RATypography variant="gilda1" left={16}>
									{selectedCategory?.min_passengers ?? 0}-{selectedCategory?.max_passengers ?? 0}
								</RATypography>
								<RATypography variant="dm_sans1" left={4}>
									PAX
								</RATypography>
							</Flex>
							<Flex alignItems="center">
								<SESpeedometer />
								<RATypography variant="gilda1" left={16}>
									{selectedCategory?.cruising_speed_mph ?? 0} Mph
								</RATypography>
								<RATypography variant="dm_sans1" left={4}>
									Cruise Speed
								</RATypography>
							</Flex>
						</div>
						<div className={s.category_info_locations}>
							{[AIRCRAFT_LOCATIONS.DETROIT, AIRCRAFT_LOCATIONS.MIAMI, AIRCRAFT_LOCATIONS.LOS_ANGELES].map(
								(loc) => (
									<button
										key={loc}
										className={s.location_button}
										style={{
											borderColor: location === loc ? "#ffb11a" : "#E9E8E8",
										}}
										onClick={() => setLocation(loc)}
									>
										{loc.replace(/_/g, " ")}
									</button>
								),
							)}
						</div>
					</Flex>
					<div className={s.category_map_wrapper}>
						<div className={s.category_map}>
							{selectedCategory && (
								<WorldMapRange location={location} type={selectedCategory.classtype} />
							)}
						</div>
					</div>
				</div>
			</div>
			<div style={{ position: "absolute", bottom: 0, left: 0, right: 0, marginBottom: 20 }}>
				<Flex justifyContent="center">
					<button className={s.explore_royal_air_fleet_button} onClick={() => setExploreFleet(!exploreFleet)}>
						{exploreFleet ? (
							<>
								<SEChevronLeft />
								<span>Back To Category</span>
							</>
						) : (
							<>
								<SERAFleetFavicon />
								<span>Explore Royal Air’s Fleet</span>
								<SEChevronRight />
							</>
						)}
					</button>
				</Flex>
				<Flex justifyContent="center" style={{ marginTop: 12 }}>
					<button
						className={isPartner ? s.explore_partner_fleet_button : s.explore_royal_air_fleet_button}
						onClick={handleNavigateToTrustedPartners}
					>
						{isPartner ? (
							<>
								<SEPartnerFleetFavicon />
								<span>Learn About Our Trusted Partners</span>
							</>
						) : (
							<>
								<SERAFleetFavicon />
								<span>Learn More About This Aircraft</span>
							</>
						)}
						<SEChevronRight />
					</button>
				</Flex>
			</div>
		</div>
	);
};

const StyledSelect = styled(Select)`
	height: 56px !important;
	&.ant-select .ant-select-selector {
		height: 56px !important;
		padding-inline: 16px !important;
	}
	&.ant-select .ant-select-selector .ant-select-selection-search-input {
		height: 54px !important;
	}
	&.ant-select .ant-select-selector .ant-select-selection-item,
	&.ant-select .ant-select-selector .ant-select-selection-placeholder {
		line-height: 54px !important;
	}
	&.ant-select .ant-select-selection-item {
		color: #222;
		font-family: "Gilda Display";
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		text-transform: capitalize;
	}
	&.ant-select .ant-select-arrow {
		inset-inline-end: 16px;
	}
`;

const DropdownRender = styled.div`
	.ant-select-item {
		height: 54px;
		padding: 0 16px;
		display: flex;
		align-items: center;
	}
	.ant-select-item-option-content {
		color: #222;
		font-family: "Gilda Display";
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		text-transform: capitalize;
	}
`;
